import React from 'react'
import ReactDOM from 'react-dom'
import Loadable from 'react-loadable'
import { Router, Route, Switch } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker'
import App from './App'
import Crop from './tools/Crop'
import { Provider } from 'react-redux'
import store from './redux/store'
import history from './services/history'
import { IntlProvider } from 'react-intl'
import { LanguageProvider, useLanguage } from './languageContext'
import messages from './locales'

const MaintenanceComponent = Loadable({
  loader: () => import('./components/MaintenanseComponent'),
  loading: () => <div />
})

const onIntlError = (err) => {
  if (err.code === 'MISSING_TRANSLATION') {
    return
  }
  console.error(err)
}

function Main () {
  const { locale } = useLanguage()

  return (
    <IntlProvider onError={onIntlError} locale={locale} messages={messages[locale]}>
      <Provider store={store}>
        <Router history={history}>
          <Switch>
            <Route exact path='/maintenanse/' render={() => <MaintenanceComponent />} />
            <Route path='/tools/crop' component={Crop} />
            <Route path='/' component={App} />
          </Switch>
        </Router>
      </Provider>
    </IntlProvider>
  )
}

ReactDOM.render(
  <LanguageProvider>
    <Main />
  </LanguageProvider>,
  document.getElementById('root')
)

registerServiceWorker()
